import React from 'react';
import { connect } from 'react-redux';
import { Form, Field, reduxForm, reset, getFormValues } from 'redux-form';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@material-ui/core/InputAdornment';

import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import {
  RenderTextField as TextField
} from '../formInputs';

import Message from '../components/Message';
import { recommendUser, getUserName, sendOtp } from '../redux/modules/user/action';
import { email, integer } from '../utils/validations';

const styles = theme => ({
  main: {
    width: 'auto',
    display: 'block', // Fix IE 11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 500,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  form: {
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  error: {
    marginTop: 10,
    color: theme.palette.error.dark,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  title: {
    marginTop: 10,
  },
  twoFactorText: {
    color: 'red',
    fontWeight: 'bold',
    marginTop: 8,
    marginBottom: 8,
  }
});

class RequestRecommendation extends React.Component {
  state = {
    message: null,
    userName: null,
    error: null
  };

  async componentDidMount() {
    const { dispatch, match } = this.props;
    try {
      const getUser = await dispatch(getUserName(match.params.id));
      this.setState({ userName: `${getUser.firstName} ${getUser.lastName}` });

    } catch (e) {
      console.log(e);
    }
  }

  submit = (props) => {
    const { dispatch, match } = this.props;

    dispatch(recommendUser(props, match.params.id))
      .then(() => {
        this.setState({ message: 'Successfully Recommended', error: null });
        dispatch(reset('RequestRecommendation'));
      })
      .catch((e) => this.setState({ error: e.message }));
  }

  close = () => {
    this.setState({
      message: null,
      error: null
    });
  }

  sendOtp = async () => {
    const { dispatch, dataToSend } = this.props;
    try {
      await dispatch(sendOtp(dataToSend.email, dataToSend.phoneNumber));
      this.setState({ message: 'OTP Send', error: null });
    } catch (e) {
      console.log(e);
    }
  }

  render() {
    const { classes, handleSubmit } = this.props;
    const { message, error, userName } = this.state;

    return (
      <main className={classes.main}>
        <Paper className={classes.paper}>

          {
            message &&
            <Message message={message} isOpen={message ? true : false} close={() => this.close()} />
          }

          <img src="/images/logo.png" alt="logo" width="130"/>
          <Typography variant="h5" className={classes.title}>Recommendation Form</Typography>
          <Form className={classes.form} onSubmit={handleSubmit(this.submit)}>
            <Typography color="primary" variant="subtitle1" className={classes.title}>
              Recommendation Requested By: {userName}
            </Typography>
            
            <Typography variant="caption" className={classes.title}>
              Please fill your details
            </Typography>

            <FormControl margin="normal" fullWidth>
              <Field name="name" component={TextField} label="Name" required />
            </FormControl>

            <FormControl margin="normal" fullWidth>
              <Field name="email" component={TextField} label="Email" required validate={email} />
            </FormControl>

            <FormControl margin="normal" fullWidth>
              <Field name="message" component={TextField} label="Message" multiline required />
            </FormControl>

            {/* <FormControl margin="normal" fullWidth>
              <Field 
                name="phoneNumber" 
                component={TextField}   
                label="Phone Number" 
                multiline 
                required 
                validate={integer} 
                InputProps={{
                  endAdornment: <InputAdornment position="end" onClick={() => this.sendOtp()}>Send Otp</InputAdornment>,
                }}
              />
            </FormControl> */}

            <FormControl margin="normal" fullWidth>
              <Field
                name="phoneNumber"
                component={TextField}
                label="Phone Number"
                required
                validate={integer}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Button 
                        onClick={() => this.sendOtp()}
                        variant="text"
                        size="small"
                        sx={{ 
                          padding: "2px 6px",
                          minWidth: "auto",
                          textTransform: "none",
                          fontSize: "12px",
                          color: "#1976d2",
                        }}
                      >
                        Verify OTP
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>


            <FormControl margin="normal" fullWidth>
              <Field name="otp" component={TextField} label="OTP" validate={integer} required />
            </FormControl>

            <Typography variant="caption" className={classes.twoFactorText}>
              {/* Secure Two-Factor Authentication (2FA) */}
              RoomerResume will send you a One Time Pass code via SMS text message to your cell phone so we can verify you.
            </Typography>

            <Button
              type="submit"
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              Send Recommendation
          </Button>

            {
              error && <p className={classes.error}>{error}</p>
            }
          </Form>
        </Paper>
      </main>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    dataToSend: getFormValues('RequestRecommendation')(state)
  }
}
export default connect(mapStateToProps)(reduxForm({
  form: 'RequestRecommendation'
})(withStyles(styles)(RequestRecommendation)));